// extracted by mini-css-extract-plugin
module.exports = {"error":"style_error__3tXyb","wrap":"style_wrap__3XuoA"};